var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16695 5.33252H31.167V21.3325H7.16695V5.33252ZM19.167 9.33252C20.2278 9.33252 21.2452 9.75395 21.9954 10.5041C22.7455 11.2542 23.167 12.2717 23.167 13.3325C23.167 14.3934 22.7455 15.4108 21.9954 16.1609C21.2452 16.9111 20.2278 17.3325 19.167 17.3325C18.1061 17.3325 17.0887 16.9111 16.3385 16.1609C15.5884 15.4108 15.167 14.3934 15.167 13.3325C15.167 12.2717 15.5884 11.2542 16.3385 10.5041C17.0887 9.75395 18.1061 9.33252 19.167 9.33252ZM12.5003 7.99919C12.5003 8.70643 12.2193 9.38471 11.7192 9.8848C11.2191 10.3849 10.5409 10.6659 9.83362 10.6659V15.9992C10.5409 15.9992 11.2191 16.2801 11.7192 16.7802C12.2193 17.2803 12.5003 17.9586 12.5003 18.6659H25.8336C25.8336 17.9586 26.1146 17.2803 26.6147 16.7802C27.1148 16.2801 27.793 15.9992 28.5003 15.9992V10.6659C27.793 10.6659 27.1148 10.3849 26.6147 9.8848C26.1146 9.38471 25.8336 8.70643 25.8336 7.99919H12.5003ZM1.83362 10.6659H4.50028V23.9992H25.8336V26.6659H1.83362V10.6659Z",
    fill: "#54AF48",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.15f03ceb.svg";
export { ForwardRef as ReactComponent };